import React, { useState, useEffect } from 'react';

export default function EditTemplateModal({ open, tpl, onClose, onSave }:{ open:boolean, tpl:any, onClose:()=>void, onSave:(t:any)=>void }){
  const [draft, setDraft] = useState<any>(tpl || {});
  useEffect(()=>{ setDraft(tpl || {}); }, [tpl]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl p-4">
        <h3 className="text-lg font-semibold mb-2">Edit Template</h3>
        <div className="space-y-2">
          <input value={draft.name||''} onChange={e=>setDraft({...draft, name: e.target.value})} className="w-full p-2 border rounded" placeholder="Name" />
          <textarea value={draft.description||''} onChange={e=>setDraft({...draft, description: e.target.value})} className="w-full p-2 border rounded" placeholder="Description" />
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1 border rounded">Cancel</button>
          <button onClick={()=>{ onSave(draft); onClose(); }} className="px-3 py-1 bg-blue-600 text-white rounded">Save</button>
        </div>
      </div>
    </div>
  );
}
